import { IRootState } from '../../../store'
import { IEmployerOptionsState } from '../store/options.types'

export const getemployerOptionsSelector = (state: IRootState): IEmployerOptionsState => state.options.employerOptions
